/**
 * set this to false to disable multilanguage system and avoid importing _all_ its dependencies
 */
let USE_I18N = true
/**
 * Set this to false if your app doesn't use the MONOGRID CMS,
 * simply setting this to false will avoid importing _all_ CMS dependencies
 */
let USE_CMS = true

/**
 * @type {import('node_modules/@vue/runtime-core/dist/runtime-core').InjectionKey<import('node_modules/vue-i18n/dist/vue-i18n').useI18n>}
 */
export const useI18nInjection = Symbol('useI18n')

/**
 * @type {import('node_modules/@vue/runtime-core/dist/runtime-core').InjectionKey<import('./i18n/index').getTranslations>}
 */
export const getTranslationsInjection = Symbol('getTranslations')

/**
 * @type {import('node_modules/@vue/runtime-core/dist/runtime-core').InjectionKey<import('./cms/CMSAuth.js').CMSAuth>}
 */
export const cmsAuthInjection = Symbol('cmsAuth')
/**
 *
 * @param {*} param0
 * @returns
 */
export const setGlobalFeatures = ({ i18n, cms }) => {
  USE_I18N = i18n
  USE_CMS = cms

  return {
    USE_CMS,
    USE_I18N
  }
}
/**
 *
 * @returns
 */
export const getGlobalFeatures = () => {
  return {
    USE_CMS,
    USE_I18N
  }
}
